import React from "react";

const Schema = () => {
  const Organization_Schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Spokój w Głowie spółka z ograniczoną odpowiedzialnością",
    url: "https://spokojwglowie.pl",
    logo: "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+48501775717",
        contactType: "Customer Service",
        email: "recepcja@spokojwglowie.pl",
      },
      {
        "@type": "ContactPoint",
        telephone: "+48721642466",
        contactType: "Customer Service",
        email: "recepcja@spokojwglowie.pl",
      },
      {
        "@type": "ContactPoint",
        telephone: "+48725396700",
        contactType: "Customer Service",
        email: "bialoleka@spokojwglowie.pl",
      },
    ],
    address: [
      {
        "@type": "PostalAddress",
        streetAddress: "ul. Miła 3, 3 piętro",
        addressLocality: "Wołomin",
        postalCode: "05-200",
        addressCountry: "PL",
      },
      {
        "@type": "PostalAddress",
        streetAddress: "ul. Mochtyńska 65",
        addressLocality: "Warszawa",
        postalCode: "03-289",
        addressCountry: "PL",
      },
    ],
    sameAs: [
      "https://www.facebook.com/spokojwglowie",
      "https://www.instagram.com/spokojwglowie.pl/",
      "https://pl.linkedin.com/company/poradnia-psychologiczna-spokój-w-głowie",
    ],
  };

  const LocalBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Spokój w Głowie spółka z ograniczoną odpowiedzialnością",
    url: "https://spokojwglowie.pl",
    logo: "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+48501775717",
        contactType: "Customer Service",
        email: "recepcja@spokojwglowie.pl",
      },
      {
        "@type": "ContactPoint",
        telephone: "+48721642466",
        contactType: "Customer Service",
        email: "recepcja@spokojwglowie.pl",
      },
      {
        "@type": "ContactPoint",
        telephone: "+48725396700",
        contactType: "Customer Service",
        email: "bialoleka@spokojwglowie.pl",
      },
    ],
    address: [
      {
        "@type": "PostalAddress",
        streetAddress: "ul. Miła 3, 3 piętro",
        addressLocality: "Wołomin",
        postalCode: "05-200",
        addressCountry: "PL",
      },
      {
        "@type": "PostalAddress",
        streetAddress: "ul. Mochtyńska 65",
        addressLocality: "Warszawa",
        postalCode: "03-289",
        addressCountry: "PL",
      },
    ],
    department: [
      {
        "@type": "LocalBusiness",
        name: "Spokój w Głowie - Wołomin",
        url: "https://spokojwglowie.pl",
        logo: "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
        image:
          "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
        telephone: "+48501775717",
        email: "recepcja@spokojwglowie.pl",
        address: {
          "@type": "PostalAddress",
          streetAddress: "ul. Miła 3, 3 piętro",
          addressLocality: "Wołomin",
          postalCode: "05-200",
          addressCountry: "PL",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "08:00",
            closes: "21:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "Saturday",
            opens: "08:00",
            closes: "19:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "Sunday",
            opens: "08:00",
            closes: "16:00",
          },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Spokój w Głowie - Warszawa",
        url: "https://spokojwglowie.pl/psycholog-warszawa/",
        logo: "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
        image:
          "https://cms.spokojwglowie.pl/wp-content/uploads/2022/07/swg_logo.png",
        telephone: "+48725396700",
        email: "bialoleka@spokojwglowie.pl",
        address: {
          "@type": "PostalAddress",
          streetAddress: "ul. Mochtyńska 65",
          addressLocality: "Warszawa",
          postalCode: "03-289",
          addressCountry: "PL",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "09:00",
            closes: "21:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "Saturday",
            opens: "08:00",
            closes: "16:00",
          },
        ],
      },
    ],
    sameAs: [
      "https://www.facebook.com/spokojwglowie",
      "https://www.instagram.com/spokojwglowie.pl/",
      "https://pl.linkedin.com/company/poradnia-psychologiczna-spokój-w-głowie",
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(Organization_Schema),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(LocalBusinessSchema),
        }}
      />
    </>
  );
};

export default Schema;
